import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as puzzleDataActions from 'klubble/app/client/actions/puzzleDataActions'
import { type StoreState } from 'client/store'
import { type PuzzlePackType } from 'client/types/PuzzlePackType'

const usePuzzlePackTypeFavorite = (puzzlePackTypeId: number) => {
  const puzzlePackTypes = useSelector<StoreState, PuzzlePackType[]>((state) => state.puzzleData?.puzzlePackTypes)
  const puzzlePackType = useMemo(() => puzzlePackTypes?.find((ppt) => ppt.id === puzzlePackTypeId), [puzzlePackTypeId, puzzlePackTypes])
  const isFavorite = puzzlePackType?.isFavorite ?? false
  const dispatch = useDispatch()

  const toggleIsFavorite = () => {
    dispatch(puzzleDataActions.setFavoritePuzzlePackType({ puzzlePackTypeId, isFavorite: !isFavorite }))
  }

  return { isFavorite, toggleIsFavorite }
}

export default usePuzzlePackTypeFavorite
